import {Typography} from "@mui/material";
import FullSizeBox from "../../../../appfw/ui/components/FullSizeBox.tsx";

export default function EmptyEventsFeedPage() {

    return (
        <FullSizeBox>
            <Typography variant={'h6'} sx={{marginTop: '6rem'}}>
                Keine Veranstaltungen
            </Typography>
        </FullSizeBox>
    )
}